import React, { useEffect, useState } from "react";
import Listado from "../components/ingresos/Listado";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

const Ingresos = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [ingresos, setIngresos] = useState([]);

  const fetchIngresos = async () => {
    const fetchAccessToken = async () => {
      try {
        return await getAccessTokenSilently();
      } catch (e: any) {
        console.log(e.message);
      }
    };

    const accessToken = await fetchAccessToken();
    console.log("API URL:", process.env.REACT_APP_API_URL);
    const apiEndpoint = `${process.env.REACT_APP_API_URL}/ingresos`;
    
    fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
    })
    .then((response) => response.json())
    .then((jsonData) => {
      console.log(jsonData);
      setIngresos(
        jsonData.data.map((ingreso: any) => {
          return {
            ingresoUUID: ingreso.uuid,
            nroTicket: ingreso.ticket,
            fecha: new Date(ingreso.fecha_ingreso),
            ubicacion: ingreso.celda,
            cantidadRollos: ingreso.cantidad_rollos,
            rollosGrabados: ingreso.rollos_grabados,
          };
        })
      );
    })
    .catch((e: any) => {
      console.log(e);
      setIngresos([]);
    });
  }

  useEffect(() => {
    fetchIngresos();
  }, []);
  return (
    <div style={{ float: "left"}}>
      <h2>Ingreso de camiones</h2>
      <p>Ingresos de la ultima semana</p>
      <Listado ingresos={ingresos} itemsPerPage={10} />
    </div>
  );
};

export default withAuthenticationRequired(Ingresos);
